// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".browse-map-button{background-color:inherit;border:none;color:var(--color-action-blue);display:inline;font-family:var(--font-medium);font-size:14px;font-weight:bold;margin:0 .1em 0 .3em;padding:0}.browse-map-button .ui-button__icon-right{margin-left:2px}.browse-map-button .ui-button__icon-right svg{height:12px;width:12px;fill:var(--color-action-blue)}", ""]);
// Exports
module.exports = exports;
